import { render, staticRenderFns } from "./VariableScopePicker.vue?vue&type=template&id=493f1f52&"
import script from "./VariableScopePicker.vue?vue&type=script&lang=js&"
export * from "./VariableScopePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports